export default "__VITE_ASSET__A4B6xi9q__"